import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=03f1d78e"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports